// extracted by mini-css-extract-plugin
export default {"mainCenter":"aboutUs_mainCenter__k4dZH"};